import { ActionReducer } from '@ngrx/store';

import { AppState } from '@core/state/interfaces';

import { storageSync } from './storage-sync';

// determine which parts of the store are persisted to session storage
export function storageSyncReducer(reducer: ActionReducer<AppState>) {
  const metaReducer = storageSync<AppState>({
    features: [
      { stateKey: 'admin' },
      { stateKey: 'auth' },
      { stateKey: 'grid' },
      { stateKey: 'inventory' },
      { stateKey: 'list' },
      { stateKey: 'order' },
      { stateKey: 'report' },
      { stateKey: 'item' },
    ],
  });

  return metaReducer(reducer);
}
